import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const partnershipPrograms = lazy(() => import('../../container/partnership-programs'));
const View = lazy(() => import('../../container/partnership-programs/View'));
const Add = lazy(() => import('../../container/partnership-programs/Add'));
const Edit = lazy(() => import('../../container/partnership-programs/Edit'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/partnership-programs`} component={partnershipPrograms} />
      <Route exact path={`${path}/partnership-programs/add`} component={Add} />
      <Route exact path={`${path}/partnership-programs/view/:id`} component={View} />
      <Route exact path={`${path}/partnership-programs/edit/:id`} component={Edit} />
    </Switch>
  );
}

export default PagesRoute;
